/* eslint-disable */

import React from "react";
import Button from "react-bootstrap/Button";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import { Link, useLocation } from "react-router-dom";
import SiteNavbar from "./SiteNavbar";

export default function AppNavbar({ hideOnScroll = false }) {
  let token = localStorage.getItem("motivar-token");
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const authAction = !token ? (
    <Link to="/user-auth" className="w-100 w-lg-auto text-decoration-none">
      <Button className="btn-primary w-100" style={{ color: "#ffffff", fontWeight: 600 }}>Sign in</Button>
    </Link>
  ) : (
    <Link to="/dashboard" className="w-100 w-lg-auto text-decoration-none">
      <Button className="btn-primary w-100" style={{ color: "#ffffff", fontWeight: 600 }}>Dashboard</Button>
    </Link>
  );

  return (
    <SiteNavbar
      hideOnScroll={hideOnScroll}
      leftNavDesktop={
        <>
          <Nav.Link
            as={Link}
            to="/explore"
            style={{
              color: isActive("/explore") ? "var(--color-primary-600)" : "var(--color-text-primary)",
              backgroundColor: isActive("/explore") ? "var(--color-primary-50)" : "transparent",
              borderRadius: "var(--radius-pill)",
            }}
          >
            Explore
          </Nav.Link>
          <NavDropdown title="Programs" id="programs-dropdown">
            <NavDropdown.Item as={Link} to="/coming-soon">DAP</NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/coming-soon">DigiAccess</NavDropdown.Item>
          </NavDropdown>
          <NavDropdown title="Community" id="community-dropdown">
            <NavDropdown.Item as={Link} to="/coming-soon">Find learners near you</NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/coming-soon">Find mentors near you</NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/coming-soon">Join accountability group</NavDropdown.Item>
          </NavDropdown>
        </>
      }
      leftNavMobile={
        <>
          <Nav.Link
            as={Link}
            to="/explore"
            style={{ color: isActive("/explore") ? "var(--color-primary-600)" : "var(--color-text-primary)" }}
          >
            Explore
          </Nav.Link>
          <NavDropdown title="Programs" id="programs-dropdown-mobile">
            <NavDropdown.Item as={Link} to="/coming-soon">DAP</NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/coming-soon">DigiAccess</NavDropdown.Item>
          </NavDropdown>
          <NavDropdown title="Community" id="community-dropdown-mobile">
            <NavDropdown.Item as={Link} to="/coming-soon">Find learners near you</NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/coming-soon">Find mentors near you</NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/coming-soon">Join accountability group</NavDropdown.Item>
          </NavDropdown>
        </>
      }
      rightContent={authAction}
    />
  );
}
